import script from "./InformationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationPage.vue?vue&type=script&setup=true&lang=js"

import "./InformationPage.vue?vue&type=style&index=0&id=3cb788ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb788ba"]])

export default __exports__